import React from 'react'

const LoadingCircle = ({className, style, sm}) => (

    <div className={`text-center ${className}`} style={style ? style : {}}>
        <div className={`lds-ring ${sm ? 'lds-ring-sm' : ''}`}><div /><div /><div /><div /></div>
    </div>
)

export default LoadingCircle;